import app from './params/app'

export const production = {
  app: app.prod
}

export default production
